<template>
  <div class="fuel-utilization page__container--no-padding">
    <div v-if="loaders.filters" class="loading-indicator"><MoonLoader size="75px"></MoonLoader></div>
    <Filters filters-shown="['dateRange', 'workOrderParams']"></Filters>
    <div class="panel panel--shaded grid">
      <div class="grid__col--5"></div>
      <div class="grid__col--2 h-center-align">
        <button class="btn btn-primary btn-block fuel-utilization__search-submit" :disabled="loaders.dateList" @click.prevent="update">Search</button>
      </div>
      <div class="grid__col--5"></div>
    </div>


    <div class="fuel-utilization-wo__container" v-if="workOrders.length">
      <div class="grid fuel-utilization__search-container">
        <div class="grid__col--9"></div>
        <div class="grid__col--3">
          <div class="fuel-utilization__search-container-input">
            <StoreConnectedSearch v-show="workOrders.length" store="fuelUtilization" name="search"></StoreConnectedSearch>
          </div>
        </div>
      </div>

      <div id="fuel-util-wo-container">
        <div class="fuel-utilization__nav-container is-hidden-mobile">
          <Affix class="fuel-utilization__nav" relative-element-selector="#fuel-util-wo-container" :offset="{ top: 71, bottom: 0 }">
            <template>
              <a :href="anchorName(status)" class="fuel-utilization__nav-item" v-smooth-scroll="{duration: 500, offset: -150}" v-for="(status, index) in statusesList" :key="index">{{ status }}</a>
            </template>
          </Affix>
        </div>

        <StatusGroup class="fuel-utilization-wo" v-for="(status, index) in statusesList" :key="index" :status="status" :work-orders="workOrderObject[status]"></StatusGroup>
      </div>
    </div>

    <div class="fuel-utilization-wo__container" v-else>
      <div class="fuel-utilization__no-data">
        <div v-if="loaders.workOrders"><MoonLoader size="75px"></MoonLoader></div>
        <div v-else-if="filtersChanged">Please run a new report to apply the current filter settings</div>
        <div v-else>You have no current work orders.</div>
      </div>
    </div>


    <a href="#top" class="btn-back-to-top"><i class="fa fa-chevron-up"></i></a>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import { Affix } from 'vue-affix';
  import Filters from '../fuel-utilization/filters/Filters.vue';
  import StatusGroup from '../fuel-utilization/StatusGroup.vue';
  import StoreConnectedSearch from '../form-items/StoreConnectedSearch.vue';

  export default {
    name: 'FuelUtilizationLayout',
    components: {
      Affix,
      MoonLoader,
      Filters,
      StatusGroup,
      StoreConnectedSearch,
    },
    computed: {
      ...mapGetters('fuelUtilization', [
        'loaders',
        'workOrderObject',
        'workOrders',
        'filtersChanged',
      ]),
      statusesList() {
        return lodash.keys(this.workOrderObject);
      },
    },
    methods: {
      anchorName(status) {
        return `#wo-${lodash.camelCase(status)}`;
      },
      update() {
        this.$store.dispatch('fuelUtilization/getWorkOrders');
      },
    },
  };
</script>
